import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column align-center pa-6 rounded",
      attrs: { "data-qa": "screen_confirm_email", rounded: "" },
    },
    [
      _c(VImg, {
        staticClass: "mb-4",
        attrs: {
          src: "/static/_v1/pd/pictures/ui-kit/mail.svg",
          width: "212",
          height: "212",
          alt: _setup.t("Почта", _setup.options),
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-center text--text",
          class: _setup.isMobile ? "text-h6 mb-4" : "text-h5 mb-2",
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_setup.t("Подтвердите ваш email", _setup.options)) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center text-body-1 text-secondary--text" },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.t(
                  "Отправили письмо для подтверждения на",
                  _setup.options
                )
              ) +
              "\n    "
          ),
          _vm.userEmail
            ? _c(
                "span",
                { attrs: { "data-qa": "screen_confirm_email_user_email" } },
                [_vm._v("\n      " + _vm._s(_vm.userEmail) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.dateOfSendingEmailText
            ? _c(
                "span",
                {
                  staticClass: "text-no-wrap",
                  attrs: {
                    "data-qa": "screen_confirm_email_date_of_sending_email",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.dateOfSendingEmailText) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }